import type { FaireProductEntity } from "../../entity_types/product";

export const p_8hv3ku3ydt: FaireProductEntity = {
  token: "p_8hv3ku3ydt",
  type: "product",
  name: "POLKA DOT PUFF SLEEVE MAXI DRESS / WL25-12140",
  brandToken: "b_1hsvo6fo88",
  brandName: "Wishlist Apparel",
  imageUrl:
    "https://cdn.faire.com/fastly/b87c1d1fddf5592184026ebbe90699a4a500e5ab5611dee248c094cbbdce9e5d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee9fbb94db33a1e1a91af3444afc896778b8b62f58eca73fcf83831db9c981b0.jpeg",
    "https://cdn.faire.com/fastly/c62ab69f48f2124966965a4eaf4c0c4e6d84c2166e8ab400acb8c24f90f249df.jpeg",
    "https://cdn.faire.com/fastly/227ccb1ae7f1e2ad01d9ba322e87236dc7dc968da809716f39ddf346debede22.jpeg",
    "https://cdn.faire.com/fastly/0ad7d6f02d459fa1343831b452b3c2585b184c1990a20f4a3552aa3d6e2375d8.jpeg",
    "https://cdn.faire.com/fastly/3714db9f35905a2847ca14e631935848aab3d272932de05217f1ea8c68a4b648.jpeg",
    "https://cdn.faire.com/fastly/bfca545f9f61ecf7e51986b655c8668429ea4b9270d0d4f4435c7542886239d6.jpeg",
    "https://cdn.faire.com/fastly/cb352aac7b207b34069212a2646dccac5159dbd6a81fc943beaa912d81c50ac2.jpeg",
  ],
  priceDollars: 249,
  description:
    'POLKA DOT PUFF SLEEVE MAXI DRESS\n- FUNCTIONAL BUTTONS, SMOCKED BODICE, SIDE POCKETS AND LINED\n- SHORT SLEEVE, SQUARE NECK, EASY, COMFY, CASUAL, EVERYDAY, SUMMER, SPRING\n\nSMALL: TOTAL LENGTH - 46 1/2"\nMODEL IS WEARING SIZE SMALL.\n\nSELF: 100% COTTON\nLINING: 100% POLYESTER\n\n* Due to lighting and differences in monitors, actual colors may vary slightly from what appears online.',
  tags: [],
  msrpDollars: 498,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:07.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
